import { AsciiText } from '../framework/AsciiText';
export class Avocor {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.00.0';
        this.input = 9; // HDMI 1 on AVE-6520
        this.power = false;
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /\x07\x01\x01\x47\x56\x45\x08/,
                callback: (match) => {
                    this.socket.send(`\x07\x01\x00\x47\x56\x45${this.firmwareVersion}\x08`);
                },
            },
            {
                name: 'inputGet',
                regExp: /\x07\x01\x01\x4D\x49\x4E\x08/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0, 0x4d, 0x49, 0x4e, this.input]));
                },
            },
            {
                name: 'inputSet',
                regExp: /\x07\x01\x02\x4D\x49\x4E([\s\S])\x08/,
                callback: (match) => {
                    this.input = match[1].charCodeAt(0);
                    this.socket.send(this.makeCommand([0, 0x4d, 0x49, 0x4e, this.input]));
                },
            },
            {
                name: 'powerGet',
                regExp: /\x07\x01\x01\x50\x4F\x57\x08/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0, 0x50, 0x4f, 0x57, this.power ? 1 : 0]));
                },
            },
            {
                name: 'powerSet',
                regExp: /\x07\x01\x02\x50\x4F\x57([\s\S])\x08/,
                callback: (match) => {
                    this.power = match[1] === '\x01';
                    this.socket.send(this.makeCommand([0, 0x50, 0x4f, 0x57, this.power ? 1 : 0]));
                },
            },
            {
                name: 'volumeGet',
                regExp: /\x07\x01\x01\x56\x4f\x4c\x08/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0, 0x56, 0x4f, 0x4c, this.volume]));
                },
            },
            {
                name: 'volumeSet',
                regExp: /\x07\x01\x02\x56\x4f\x4c([\s\S])\x08/,
                callback: (match) => {
                    this.volume = match[1].charCodeAt(0);
                    this.socket.send(this.makeCommand([0, 0x56, 0x4f, 0x4c, this.volume]));
                },
            },
            {
                name: 'volumeMuteGet',
                regExp: /\x07\x01\x01\x4D\x55\x54\x08/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0, 0x4d, 0x55, 0x54, this.volumeMute ? 1 : 0]));
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /\x07\x01\x02\x4D\x55\x54([\s\S])\x08/,
                callback: (match) => {
                    this.volumeMute = match[1] === '\x01';
                    this.socket.send(this.makeCommand([0, 0x4d, 0x55, 0x54, this.volumeMute ? 1 : 0]));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/,
                callback: (match) => {
                    this.socket.send('Error');
                },
            },
        ];
    }
    makeCommand(data) {
        data.unshift(0x07, 0x01); // Add STX and IDT to the beginning
        data.push(0x08); // Add ETX to end
        return AsciiText.decode(data);
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code.charCodeAt(0);
            if (this.input === code - 0x30)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.input = (lowestCode !== null && lowestCode !== void 0 ? lowestCode : 0x3d) - 0x30;
    }
}
Avocor.emulatorType = 'socketEmulator';
Avocor.key = '-MTu3vySEY92FvLP8usb';
